
export function GetFileUploadRequest(
	this: any,
) {
	const { caseId, caseType, file, storageType } = this;
	
	const formData = new FormData();
	   formData.append("entityId", caseId);
       formData.append("entityType", caseType);
       formData.append("noteText","");
	   formData.append("addToHistory","true");
	   formData.append("documentType","");
	   formData.append("StorageType",storageType);
	   formData.append("file0", file, file.name);
	
	   return formData
}
